import { render, staticRenderFns } from "./SaPageLayout.vue?vue&type=template&id=3d89ccf2"
import script from "./SaPageLayout.vue?vue&type=script&lang=js"
export * from "./SaPageLayout.vue?vue&type=script&lang=js"
import style0 from "./SaPageLayout.vue?vue&type=style&index=0&id=3d89ccf2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports